<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table :config="config" hide-upsert title="MedDRA Lower level term list">

          <template slot='headerActions'>
            <slot name='headerActions'/>
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                  <v-btn
                    v-on="on"
                    :loading="loadingImport"
                    v-if="$can('import', 'meddra')"
                    color="secondary"
                    @click="importZip()">
                    <v-icon>mdi-upload</v-icon>
                  </v-btn>
              </template>
              <span>Update MedDRA database</span>
            </v-tooltip>
          </template>

        </core-table>
      </v-flex>
    </v-layout>
    <app-meddra-upload-modal v-model="importModal" />
  </v-container>
</template>

<script>

import config from './config_index.js'

export default {
  data () {
    return { 
      config,
      loadingImport:false,
      importModal: false
    }
  },
  methods: {
    importZip() {
      this.importModal = true
    }
  }
}
</script>
